export default "__VITE_ASSET__8f77aba2__"